import { z } from 'zod';
import { startOfDay } from 'date-fns';

const notFutureDate = (message: string) =>
  z
    .date({ required_error: 'This field is required', invalid_type_error: 'This field is required' })
    .refine((date) => startOfDay(date) <= startOfDay(new Date()), { message });

export const ddiSsnSearchResultSchema = z.object({
  date: notFutureDate('Date cannot be in the future'),
  ssn: z.preprocess(
    (value) => value ?? '',
    z
      .string()
      .min(1, 'SSN is required')
      .regex(/^[0-9-]+$/, 'SSN must contain only numbers and -')
      .min(11, 'SSN is invalid')
  ),
  dob: notFutureDate('DOB cannot be in the future'),
  notes: z.string().optional().nullable(),
});

export type DdiSsnSearchResultFormValues = z.infer<typeof ddiSsnSearchResultSchema>;
